<template>
  <!--<div id="topiclist"  v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">-->
  <!--<ul>-->
  <!--&lt;!&ndash;<li v-for="item in topicList" :key="item.topicID">&ndash;&gt;-->
  <!--<li v-for="item in topicLists" :key="item.topicID">-->
  <!--<list-head :item="item"></list-head>-->
  <!--<list-content :content="item.content" :attUrls="item.attUrls" :discussID="item.discussID"></list-content>-->
  <!--</li>-->
  <!--</ul>-->
  <!--</div>-->
  <div class="out">
    <pullScroll :on-refresh="onRefresh" :on-infinite="onInfinite" :loading-text="loadingText"
                :enableInfinite="enableInfinite">
      <ul id="topicList">
        <li v-for="item in topicLists" :key="item.id">
          <!--          <list-head :topicItem="item" :themeColor="themeColor"></list-head>-->
          <!--          <list-content :content="item.content" :attUrls="item.attUrls" :discussID="item.discussID"-->
          <!--                        :themeColor="themeColor" :topicItem="item"></list-content>-->
          <discussDetail :discussItem="item" @showSwiper="detailShowSwiper"
                         @detailShowPopover="detailShowPopover" :sid="sid"></discussDetail>

        </li>
      </ul>
    </pullScroll>
  </div>
  <!--<div id="topicList">-->
  <!--<pullTo @infinite-scroll="onInfinite" >-->
  <!--<ul>-->
  <!--<li v-for="item in topicLists" :key="item.topicID">-->
  <!--<list-head :item="item"></list-head>-->
  <!--<list-content :content="item.content" :attUrls="item.attUrls" :discussID="item.discussID"></list-content>-->
  <!--</li>-->
  <!--</ul>-->
  <!--</pullTo>-->
  <!--</div>-->

</template>

<script>

  import PullRefresh from '../common/PullRefresh.vue'
  //  import pullTo from '../common/vue-pull-to.vue'
  import listHead from './listhead.vue'
  import listContent from './listcontent.vue'
  import discussDetail from '../discussDetail/discussDetail'
  import submit from '../../tool/submit'
  import utils from '../../tool/utils'
  // import $ from 'jquery'

  export default {
    props: ['sid', 'govImage', 'topicID', 'themeColor'],
    data () {
      return {
        topicLists: [],
        refreshList: [],
        busy: true,
        page: -1,
        pageSize: 10,
        loadingText: '加载中...',
        enableInfinite: true,
        once: false
      }
    },
    components: {
      listHead,
      listContent,
      'pullScroll': PullRefresh,
      discussDetail
    },
    watch: {
      topicLists: {
        handler (cur, old) {
        },
        deep: true
      }
    },
    mounted () {
      // this.busy = true
      // this.page = -1
      // this.pageSize = 10
      // this.loadingText = '加载中...'
      // this.enableInfinite = true
      // this.once = false
      // this.onRefresh()

      setTimeout(function () {
        utils.videoPlayOne()
      }, 500)
    },
    methods: {
      onInfinite: function (done) {
        let _this = this
        _this.page++
        // setTimeout(() => {
        // axios.get(`/topicApi/getDiscussList?topicID=${this.topicID}&pageNum=${this.topicID}&sid=${this.sid}`)
        submit.getDiscussList({
          sid: _this.sid,
          topicID: _this.topicID,
          pageNum: _this.page
        }).then((response) => {
          if (response.data && response.data.success) {
            // _this.topicLists = _this.topicLists.concat(response.data.list)
            _this.topicLists = _this.topicLists.concat(submit.parseImageStyle(response.data.list, response.data.config))
            _this.$forceUpdate()
            setTimeout(function () {
              utils.videoPlayOne()
            }, 500)
          }
          if (response.data.list && response.data.list.length === 10) {
            _this.enableInfinite = true
          } else {
            if (typeof response.data.list === 'undefined') {
              _this.loadingText = '暂时没内容...'
            } else if (_this.topicLists.length >= 0) {
              _this.loadingText = '没有更多了...'
            } else {
              _this.loadingText = '加载中...'
            }
            _this.enableInfinite = false
          }
          typeof done === 'function' && done()
        })
          .catch(function (error) {
            console.log(error)
          })
        // }, 1000)
      },
      onRefresh: function (refreshDone) {
        var _this = this
        _this.once = true
        _this.page = 0
        submit.getDiscussList({
          sid: _this.sid,
          topicID: _this.topicID,
          pageNum: 0
        }).then((response) => {
          if (response.data && response.data.success) {
            _this.topicLists = this.topicLists.splice(0, 0).concat(submit.parseImageStyle(response.data.list))
            _this.$forceUpdate()
          }
          if (response.data.list && response.data.list.length === 10) {
            _this.enableInfinite = true
            _this.loadingText = '加载中...'
          } else {
            if (typeof response.data.list === 'undefined' || _this.topicLists.length === 0) {
              _this.loadingText = '暂时没内容...'
            } else if (_this.topicLists.length >= 0) {
              if (_this.topicLists.length === 0) {
                _this.loadingText = '暂时没内容...'
              } else {
                _this.loadingText = '没有更多了...'
              }
            } else {
              _this.loadingText = '加载中...'
            }
            _this.enableInfinite = false
          }

          typeof refreshDone === 'function' && refreshDone()
        })
          .catch(function (error) {
            _this.loadingText = '暂时没内容...'
            console.log(error)
          })
      },
      detailShowSwiper: function (list, index) {
        this.$emit('topicShowSwiper', list, index)
      },
      detailShowPopover: function () {
        this.$emit('showPopover')
      }
    },
    destroyed () {
      this.busy = true
      this.page = -1
      this.pageSize = 10
      this.loadingText = '加载中...'
      this.enableInfinite = true
      this.once = false
    }
  }
</script>

<style scoped>
  .out {
    position: relative;
  }

  ul {
    margin-bottom: 10px;
    padding-top: 0.1rem;
  }

  li .discuss {
    border-bottom: 0.01rem solid #dddddd;
    margin: 0 0.3rem;
    padding: 0.28rem 0 0.3rem;
  }

  li:first-child .discuss {

  }

</style>



// WEBPACK FOOTER //
// list.vue?37d59b70